export default {
  scorecard: {
    title: 'Score Card',
    content: 'Content',
    award: 'ESG Award',
  },
  list_table_filter: {
    table_buyer_company_name: 'Buyer',
    table_question_group_name: 'Survey',
    table_status: 'Status',
    table_issue_at: 'Date issued',
    table_sustaina_rate: 'ESG Rating',
    table_esg_score: 'ESG Score',
    table_operation: 'Operation',
    number_of_suppliers: 'Number of suppliers',
    displayed_items_number: 'Show {start}-{end} of {total} companies',
    displayed_items_number_empty: 'Show 0 of 0 companies',
    no_data_display: 'No data is available',
    csv_modal_title: 'Please select items to be exported on CSV',
    csv_modal_answer_status_title: 'Answer Status',
    csv_modal_answer_status_text: "Export suppliers' answer status list.",
    csv_modal_answer_title: 'Answer (1file per 500 companies)',
    csv_modal_answer_title_by_individual_company: 'Answer (1file per company)',
    csv_modal_answer_text: 'The answers of suppliers will be output in 1file per 500companies.',
    csv_modal_answer_text_by_individual_company: 'The answers of suppliers will be output in 1file per 1company.',
    csv_modal_score_title: 'Score',
    csv_modal_score_text: 'Export ratings and scores of suppliers.',
    csv_modal_answer_heading: 'Header',
    csv_modal_answer_heading_supplier: 'Supplier',
    csv_modal_answer_heading_question: 'Question',
    csv_modal_answer_additional: 'Additional Item',
    csv_modal_answer_additional_note: 'Notes',
    csv_modal_answer_additional_file: 'Attached File Name',
    csv_modal_cautionary_note_title: 'Notice',
    csv_modal_cautionary_note_content: '・The output file includes "answer status", "answer" and "score" for "{questionGroupName}".\n・For "answer status", all registered companies are included, regardless of their answer status on the survey.\n・For "answer" and "score", companies with a answer status of “In Progress” are not included in the output file.\n・The maximum number of companies that can be displayed in a single CSV file for "answer" and "score" is 500.\n・The CSV file will be sent to the email address of the currently logged-in account.',
    csv_modal_sent_mail_section_one: 'Your CSV export request has been accepted.',
    csv_modal_sent_mail_section_two: 'Please wait a moment until an email with the URL to download the CSV will be sent to your e-mail address.',
    csv_modal_sent_mail_section_three: 'If you do not receive an e-mail within 30 minutes, please try again.',
  },
  overall_score_section: {
    card_title: 'Survey Content',
    score: 'Score',
    esg_score: 'ESG Score',
    esg_rating: 'ESG Rating',
    esg_score_tip: "The ESG score is an evaluation of your company's ESG activities.It is calculated based on your answers to the ASUENE ESG survey.",
    esg_rating_tip: "ESG rating is an absolute evaluation of the level of your company's ESG activities categorized on a seven-point scale from AAA to CCC based on your ESG score.",
    evaluator_advice_title: 'Assessment Comment',
    list_header_buyer_company_name: 'Buyer',
    list_header_supplier_company_name: 'Supplier',
    list_header_question: '@:common.upload.title',
    list_header_create_at: 'Date issued',
    list_header_deadline: 'Validity period',
    list_header_industry: 'Industry',
    list_header_company_scale: 'Number of Employees',
    download_csv: 'CSV Export',
    download_pdf: 'PDF Export',
    csv_title_for_buyer: 'ASUENE ESG survey answers',
    csv_title_for_supplier: 'ASUENE ESG',
    answer: '@:upload_common.question_group_download_answered_csv_title',
    download_answer_description: 'Download answers in csv.',
    answer_pdf: '@:upload_common.question_group_download_answered_pdf_title',
    download_answer_pdf_description: 'Download answers in pdf.',
    scorecard_pdf: 'Scorecard(PDF)',
    download_scorecard_pdf_description: 'Download score in pdf.',
    feedback: 'Assessment feedback',
    attached_file: "@:{'improvementplans.attached_file'}",
    download_feedback_description: 'The document will be downloaded in PDF.',
    award_medal_svg: 'ESG Award Medal(SVG)',
    download_award_medal_svg_description: 'The medal will be downloaded in SVG.',
    award_medal_png: 'ESG Award Medal(PNG)',
    download_award_medal_png_description: 'The medal will be downloaded in PNG.',
    pdf_modal_sent_mail_section_one: 'Your PDF export request has been accepted.',
    pdf_modal_sent_mail_section_two: 'Please wait a moment until an email with the URL to download the PDF will be sent to your e-mail address.',
    pdf_modal_sent_mail_section_three: 'If you do not receive an e-mail within 30 minutes, please try again.',
  },
  category_score_section: {
    card_title: 'Score by Category',
    tip: 'A category score is a score for environmental, social, and governance category of your company. The weighting of the questions in each category varies by company.',
    policy: 'Policy',
    action: 'Action',
    result: 'Result',
  },
  score_by_category_compared_section: {
    card_title: 'Score Comparison by Category',
    get_score_by_category: "Your Company's Category Score",
    esg_evaluated_all_companies_average: 'All companies assessed by ASUENE ESG',
    tip: 'This is the average score of companies that answered to the same survey.',
  },
  strengths_advice_section: {
    card_title: 'Strength, advice',
    strong_point: 'Strength',
    advice: 'Improvements',
    policies: 'Policy',
    action: 'Action',
    result: 'Result',
    no_results_for_this_category: 'No results exist for this category.',
    risk: 'Risk',
    indicator: 'Indicator',
    content: 'Content',
    operation: 'Operation',
    item: '@:improvementplans.unit',
    no_data_display: 'No corresponding data is registered.',
  },
  preview: {
    go_back_to_scorecard: 'Go back to Scorecard',
  },
  buyer_scorecard: {
    overview_card_title: '@:overall_score_section.card_title',
    score_card_title: '@:list_table_filter.csv_modal_score_title',
    evaluation_comment_card_title: 'Overall score summary',
    category_card_tabs_risk: '@:improvementplans.risk',
    category_card_tabs_content: '@:scorecard.content',
    category_card_tabs_operation: '@:improvementplans.operation',
    category_card_score_title: '@:list_table_filter.csv_modal_score_title',
    category_card_score_average: 'Average Score:',
    category_card_score_no_score: 'Not applicable',
    category_card_score_earned_score: 'Your Score',
    category_card_details_list_title: 'Assessment comment',
    category_card_details_no_score_tip: 'This category is not applicable for evaluation.',
    category_card_score_average_score: 'Average score of all companies',
    category_card_details_title: 'Category score summary',
    category_card_details_strengths: '@:strengths_advice_section.strong_point',
    category_card_details_indicated_points: '@:strengths_advice_section.advice',
    no_score_tip: "This item is not applicabe as the survey is assessed according to the buyer's logic.",
    buyer_evaluate_tip: "This item is assessed according to the buyer's logic. It is not assessed based on Asuene ESG's Scoring logic.",
    answer_rejection_notification: 'You received a new withdrawal request',
    answer_rejection_modal_title: 'Send back submission',
    answer_rejection_modal_text: 'Send back comment',
    answer_rejection_modal_content: '{companyName}s answer will be sent back. \nPlease write a comment for the reason of sending back',
    answer_rejection_dialog_content: '{companyName}s answer has been sent back',
    answer_rejection_button_title: 'Send back',
  },
}
